import React, { useState, Children, cloneElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChefHat, Bath, PaintRoller, Grid, PlusSquare, DoorOpen, Home, CloudRain, Hammer, Settings, Calendar, Wrench, ArrowRight, Flower2 } from 'lucide-react';
export function Services() {
  const [activeTab, setActiveTab] = useState('interior');
  const tabs = [{
    id: 'interior',
    label: 'Interior Transformations'
  }, {
    id: 'exterior',
    label: 'Exterior Excellence'
  }, {
    id: 'care',
    label: 'Complete Property Care'
  }];
  const servicesData = {
    interior: [{
      icon: <ChefHat data-id="element-385" />,
      title: 'Kitchen Remodeling',
      desc: "A kitchen so beautiful you'll want to host every holiday",
      image: 'https://cdn.magicpatterns.com/uploads/uw3QK8sNWAjWYbbqDa4cfX/bluesky3.png'
    }, {
      icon: <Bath data-id="element-386" />,
      title: 'Bathroom Remodeling',
      desc: 'Your personal sanctuary — spa-level finish, built to last',
      image: 'https://cdn.magicpatterns.com/uploads/k3zGSf2qMDPgnzRvehCZjz/bluesky2.png'
    }, {
      icon: <Hammer data-id="element-387" />,
      title: 'Basement Finishing',
      desc: 'Transform unused space into the room your family always wanted',
      image: 'https://cdn.magicpatterns.com/uploads/4KDdgMU4deYPsvk9AHfRSE/bluesky4.png'
    }, {
      icon: <PaintRoller data-id="element-388" />,
      title: 'Drywall & Painting',
      desc: 'Flawless, clean, professional — walls that set the whole tone',
      image: 'https://cdn.magicpatterns.com/uploads/svH2xab4U5CT9pKYYj1pPt/bluesky5.png'
    }, {
      icon: <Grid data-id="element-389" />,
      title: 'Flooring Installation',
      desc: 'From hardwood to tile — floors that make every room feel premium',
      image: 'https://cdn.magicpatterns.com/uploads/5ZACHEyg39dWXJzE48eyVF/bluesky9.png'
    }, {
      icon: <PlusSquare data-id="element-390" />,
      title: 'Home Additions',
      desc: 'Need more space to grow? We build it beautifully',
      image: 'https://cdn.magicpatterns.com/uploads/awUhHvRmMBvStZ4JkfQgwc/bluesky6.png'
    }, {
      icon: <DoorOpen data-id="element-391" />,
      title: 'Doors & Windows',
      desc: 'New light, new energy, better insulation — transformative upgrades',
      image: 'https://cdn.magicpatterns.com/uploads/iBiWNVY4e8tur3SmUwkDBh/bluesky7.png'
    }],
    exterior: [{
      icon: <Home data-id="element-392" />,
      title: 'Roofing & Repair',
      desc: 'A strong, beautiful roof that protects everything underneath it',
      image: 'https://images.unsplash.com/photo-1632759145351-1d592919f522?w=600&q=80'
    }, {
      icon: <CloudRain data-id="element-393" />,
      title: 'Gutters',
      desc: 'Clean water management — quietly protecting your investment',
      image: 'https://cdn.magicpatterns.com/uploads/2icSEuf7Frxjn1ZHe7zMn6/bluesky8.png'
    }, {
      icon: <Hammer data-id="element-394" />,
      title: 'Custom Decks',
      desc: 'Your perfect outdoor living space, built to Pennsylvania winters',
      image: 'https://images.unsplash.com/photo-1591825729269-caeb344f6df2?w=600&q=80'
    }, {
      icon: <Flower2 data-id="element-395" />,
      title: 'Gardening Design',
      desc: 'Beautiful landscapes and garden spaces that bring your yard to life',
      image: 'https://cdn.magicpatterns.com/uploads/eqCnDRMfMZeMj4p51ABMi9/bluesky15.png'
    }],
    care: [{
      icon: <Settings data-id="element-396" />,
      title: 'Property Management',
      desc: "We take care of everything — so you don't have to worry",
      image: 'https://cdn.magicpatterns.com/uploads/1NJ2ibLQrEPrnEnvD9125V/bluesky10.png'
    }, {
      icon: <Calendar data-id="element-397" />,
      title: 'Seasonal Services',
      desc: 'Year-round maintenance keeping your property in peak condition',
      image: 'https://cdn.magicpatterns.com/uploads/7pedVwnGQ3CdEwXsMvBoZT/bluesky11.png'
    }, {
      icon: <Wrench data-id="element-398" />,
      title: 'Repairs & Upgrades',
      desc: 'Fast, clean, professional — no job too small',
      image: 'https://cdn.magicpatterns.com/uploads/k8M7APgmzjzYer3bxZ9bva/bluesky9.png'
    }]
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  return <section id="services" className="py-32 bg-white" data-id="element-399">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-400">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-401">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-402">
            <div className="flex items-center justify-center gap-4 mb-6" data-id="element-403">
              <div className="h-px w-12 bg-gold" data-id="element-404"></div>
              <span className="text-gold font-bold uppercase tracking-widest text-xs" data-id="element-405">
                Everything Your Home Deserves
              </span>
              <div className="h-px w-12 bg-gold" data-id="element-406"></div>
            </div>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-navy mb-6" data-id="element-407">
              Our Premium Services
            </h2>
            <p className="text-lg text-muted font-light leading-relaxed" data-id="element-408">
              From stunning interiors to durable exteriors — every project is
              built with precision, pride, and premium materials.
            </p>
          </motion.div>
        </div>

        {/* Refined Tabs */}
        <div className="flex flex-wrap justify-center gap-8 md:gap-12 mb-16 border-b border-gray-100" data-id="element-409">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`relative pb-4 text-sm md:text-base font-bold uppercase tracking-widest transition-colors duration-300 ${activeTab === tab.id ? 'text-navy' : 'text-muted hover:text-navy'}`} data-id="element-410">
              {tab.label}
              {activeTab === tab.id && <motion.div layoutId="activeServiceTab" className="absolute bottom-0 left-0 right-0 h-0.5 bg-gold" transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} data-id="element-411" />}
            </button>)}
        </div>

        {/* Content */}
        <div className="min-h-[600px]" data-id="element-412">
          <AnimatePresence mode="wait" data-id="element-413">
            <motion.div key={activeTab} variants={containerVariants} initial="hidden" animate="visible" exit="exit" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-414">
              {servicesData[activeTab as keyof typeof servicesData].map((service, index) => <motion.div key={index} variants={itemVariants} className="group relative h-80 md:h-96 rounded-2xl overflow-hidden shadow-lg cursor-pointer" data-id="element-415">
                    {/* Background Image */}
                    <div className="absolute inset-0 w-full h-full" data-id="element-416">
                      <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-417" />
                    </div>

                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-navy/95 via-navy/60 to-navy/10 transition-opacity duration-500 group-hover:opacity-90" data-id="element-418"></div>

                    {/* Icon Badge */}
                    <div className="absolute top-6 left-6 w-12 h-12 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center text-white border border-white/20" data-id="element-419">
                      {cloneElement(service.icon as React.ReactElement, {
                  size: 20
                })}
                    </div>

                    {/* Content */}
                    <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end" data-id="element-420">
                      <h3 className="text-2xl font-heading font-bold text-white mb-3 transform transition-transform duration-500 group-hover:-translate-y-2" data-id="element-421">
                        {service.title}
                      </h3>
                      <p className="text-sm font-light text-white/80 leading-relaxed mb-6 transform transition-transform duration-500 group-hover:-translate-y-2" data-id="element-422">
                        {service.desc}
                      </p>

                      {/* CTA Link */}
                      <a href="#contact" className="flex items-center gap-2 text-gold text-xs font-bold uppercase tracking-widest opacity-0 transform translate-y-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0" data-id="element-423">
                        <span data-id="element-424">Get a Quote</span>
                        <ArrowRight size={14} data-id="element-425" />
                      </a>
                    </div>
                  </motion.div>)}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}